@if (props["cardStyle"]) {
  <div [class]="noteClass" [style.marginTop]="marginTop + 'rem'" [style.marginBottom]="marginBottom + 'rem'" pRipple>
    <div class="flex flex-row items-start gap-3">
      @if (props["showIcon"]) {
        <div class="flex-shrink-0">
          <i [class]="'pi ' + icon"></i>
        </div>
      }
      <div class="flex-1">
        <div class="wysiwyg-content" [innerHTML]="content"></div>
      </div>
    </div>
  </div>
} @else {
  <div
    class="flex flex-row min-h-[1rem] h-fit items-start gap-3"
    [style.marginTop]="marginTop + 'rem'"
    [style.marginBottom]="marginBottom + 'rem'"
  >
    @if (props["showIcon"]) {
      <div class="flex-shrink-0">
        <i [class]="'pi ' + icon"></i>
      </div>
    }
    <div class="flex-1">
      <div class="wysiwyg-content" [innerHTML]="content"></div>
    </div>
  </div>
}
